import { j as a } from "./jsx-runtime-DmTjM30f.mjs";
import { I as b } from "./ic_add-Vjwi0Osr.mjs";
import "react";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { e as x } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as p } from "./index-BpNK5r1N.mjs";
const y = ["medium", "large", "xlarge"], f = p(["flex items-center justify-center rounded-full  tabular-nums"], {
  variants: {
    hasIcon: {
      true: "",
      false: ""
    },
    type: {
      filled_basic: "bg-fill-neutral-weak text-text-neutral-main",
      filled_blackop: "bg-opacity-black-50 text-static-white"
    },
    size: {
      xlarge: "min-h-32 typography-body-14-regular",
      large: "min-h-26 typography-body-12-regular",
      medium: "min-h-20 py-2 typography-label-10-regular"
    },
    pcSize: {
      xlarge: "pc:min-h-32 pc:typography-body-14-regular",
      large: "pc:min-h-26 pc:typography-body-12-regular",
      medium: "pc:min-h-20 py-2 pc:typography-label-10-regular"
    }
  },
  compoundVariants: [
    ...y.flatMap((e) => [
      {
        hasIcon: !0,
        size: e,
        className: {
          medium: "px-4 min-w-58",
          large: "pl-6 pr-8 min-w-70",
          xlarge: "pl-6 pr-8 min-w-82"
        }[e]
      },
      {
        hasIcon: !1,
        size: e,
        className: {
          medium: "pl-6 pr-10 min-w-52",
          large: "pl-8 pr-12 min-w-60",
          xlarge: "pl-12 pr-16 min-w-76"
        }[e]
      },
      {
        hasIcon: !0,
        pcSize: e,
        className: {
          medium: "pc:px-4 pc:min-w-58",
          large: "pc:pl-6 pc:pr-8 pc:min-w-70",
          xlarge: "pc:pl-6 pc:pr-8 pc:min-w-82"
        }[e]
      },
      {
        hasIcon: !1,
        pcSize: e,
        className: {
          medium: "pc:pl-6 pc:pr-10 pc:min-w-52",
          large: "pc:pl-8 pc:pr-12 pc:min-w-60",
          xlarge: "pc:pl-12 pc:pr-16 pc:min-w-76"
        }[e]
      }
    ])
  ]
}), h = p("", {
  variants: {
    size: {
      xlarge: "size-14",
      large: "size-14",
      medium: "size-12"
    },
    pcSize: {
      xlarge: "pc:size-14",
      large: "pc:size-14",
      medium: "pc:size-12"
    }
  }
}), I = p("font-bold", {
  variants: {
    hasIcon: {
      true: "",
      false: "!pl-4 !pc:pl-4"
    },
    size: {
      xlarge: "pl-8",
      large: "pl-6",
      medium: "pl-4"
    },
    pcSize: {
      xlarge: "pc:pl-8",
      large: "pc:pl-6",
      medium: "pc:pl-4"
    }
  }
}), v = p("shrink-0", {
  variants: {
    type: {
      filled_basic: "hover-never:[&>div]:bg-fill-neutral-weak1 focus:[&>div]:bg-fill-neutral-weak1",
      filled_blackop: "hover-never:[&>div]:bg-opacity-black-60 focus:[&>div]:bg-opacity-black-60"
    }
  }
}), w = ({
  currentPage: e,
  totalPages: c,
  type: r = "filled_basic",
  size: n,
  onClickAll: l
}) => {
  const o = `${e}`.padStart(2, "0"), m = `${c}`.padStart(2, "0"), i = typeof l == "function", t = x({
    property: n,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: { mobile: "medium", pc: "large" }
  }), u = f({ type: r, hasIcon: i, ...t }), d = h({ ...t }), g = I({ hasIcon: i, ...t });
  return /* @__PURE__ */ a.jsx(N, { onClick: l, type: r, children: /* @__PURE__ */ a.jsxs("div", { className: u, children: [
    /* @__PURE__ */ a.jsx("span", { className: g, children: o }),
    /* @__PURE__ */ a.jsxs("span", { children: [
      /* @__PURE__ */ a.jsx("span", { className: "mx-2", children: "/" }),
      /* @__PURE__ */ a.jsx("span", { children: m })
    ] }),
    i ? /* @__PURE__ */ a.jsx("div", { className: d, children: /* @__PURE__ */ a.jsx(b, { className: "size-full" }) }) : null
  ] }) });
}, N = ({
  children: e,
  type: c,
  onClick: r
}) => {
  const n = typeof r == "function", l = v({ type: c });
  return n ? /* @__PURE__ */ a.jsx("button", { "aria-label": "전체보기", className: s(l), onClick: r, type: "button", children: e }) : /* @__PURE__ */ a.jsx("div", { className: s(["inline-flex", "shrink-0"]), children: e });
};
w.displayName = "NDS.NumberIndicator";
export {
  w as N
};
